// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"531":"85fcc","857":"817d5"}[chunkId] + ".css";
};